import { z } from 'zod';
import { zAdminAction } from './adminAction.js';
import { zAffinity } from './affinity.js';
import { zBasicPost, zFullBasicPost } from './basicPost.js';
import { zBlock } from './block.js';
import { zBusiness } from './business.js';
import { zComment } from './comment.js';
import { zEmailNotification } from './emailNotification.js';
import { zEvent, zFullEvent } from './event.js';
import { zFeedback } from './feedback.js';
import { zDummy } from './model.js';
import { zNotification } from './notification.js';
import { zFullPoll, zPoll } from './poll.js';
import { zPollResponse } from './pollResponse.js';
import { zReport } from './report.js';
import { zSiteSettings } from './siteSettings.js';
import { zStarredBusiness } from './starredBusiness.js';
import { zUser } from './user.js';
import { zUserLogin } from './userLogin.js';
import { zTelemetry } from './telemetry.js';
import { zCommunityQuestion, zFullCommunityQuestion } from './communityQuestion.js';
import { zBackup } from './backup.js';
import { zBusinessPost, zFullBusinessPost } from './businessPost.js';
import { zBusinessCheckIn, zFullBusinessCheckIn } from './businessCheckIn.js';
import { zMarketplaceItem, zFullMarketplaceItem } from './marketplaceItem.js';
import { PostTypesLookup } from './post.js';
import { zUserLedger } from './userLedger.js';
import { zEmailLog } from './emailLog.js';
import { zPostView } from './postView.js';
import { zDirectMessage } from './directMessage.js';
import { zJob } from './job.js';
export function isPost(doc) {
    return PostTypesLookup[doc.postType] !== undefined;
}
export const zPost = z.discriminatedUnion('postType', [
    zBasicPost,
    zEvent,
    zPoll,
    zCommunityQuestion,
    zBusinessCheckIn,
    zBusinessPost,
    zMarketplaceItem
]);
export const zFullPost = z.discriminatedUnion('postType', [
    zFullBasicPost,
    zFullEvent,
    zFullPoll,
    zFullCommunityQuestion,
    zFullBusinessCheckIn,
    zFullBusinessPost,
    zFullMarketplaceItem
]);
export const FieldShapes = {
    feedback: zFeedback,
    post: zPost,
    comment: zComment,
    block: zBlock,
    report: zReport,
    business: zBusiness,
    affinity: zAffinity,
    user: zUser,
    starredBusiness: zStarredBusiness,
    dummy: zDummy,
    adminAction: zAdminAction,
    userLogin: zUserLogin,
    siteSettings: zSiteSettings,
    pollResponse: zPollResponse,
    notification: zNotification,
    emailNotification: zEmailNotification,
    telemetry: zTelemetry,
    backup: zBackup,
    userLedger: zUserLedger,
    emailLog: zEmailLog,
    postView: zPostView,
    directMessage: zDirectMessage,
    job: zJob
};
